import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { ComponentType, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { loginPath } from 'src/components/Navbar';
import { getUserRoles } from 'src/utils/authRoles';

export default function ProtectedRoute({
  Component,
  allowedRoles,
  preserveSearch = false,
}: {
  Component: ComponentType<object>;
  allowedRoles?: readonly string[];
  preserveSearch?: boolean;
}): JSX.Element {
  // Keep the authenticated component type stable across Auth0 token refreshes.
  const MyComponent = useMemo(
    () =>
      withAuthenticationRequired(Component, {
        returnTo: preserveSearch
          ? (): string => window.location.pathname + window.location.search
          : window.location.pathname,
      }),
    [Component, preserveSearch],
  );
  const { isAuthenticated, isLoading, user } = useAuth0();

  if (process.env.CYPRESS_AUTH_MOCKED === 'true')
    return (
      <div>
        <Component />
      </div>
    );

  if (allowedRoles && isLoading) return <div>Loading...</div>;
  if (allowedRoles && isAuthenticated) {
    const roles = getUserRoles(user as Record<string, unknown> | undefined);
    const isAllowed = roles.some((role) => allowedRoles.includes(role));
    if (!isAllowed) return <Navigate to={loginPath} replace />;
  }

  return <MyComponent />;
}
